import BaseSliderManager from "../../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { eventBus, EnumEventBus } from "./EventBus";
import Checkbox from "../../../../../src/entities/UI/Checkbox/Checkbox";
import { ANGLE_COLORS, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";
import { SliderGenProps } from "../../../../../src/types/Interface";


const SliderGen: SliderGenProps[] = [
  {
    head: "grow shape",
    colors: {
      bgColor: 0x21D4FE,
      barColor: 0x000000,
      buttonColor: 0x21D4FE
    },
    keepCurrSlider: true,
    onUpdate: (v: number) => eventBus.emit(EnumEventBus.setGrowCircleValue, v - 100)
  },
  {
    head: "move the points",
    subHead: "(select which one to use)",
    colors: {
      bgColor: 0xBFBFBF,
      barColor: 0x000000,
      buttonColor: 0x000000
    },
    onUpdate: (v: number) => eventBus.emit(EnumEventBus.movePoints, v - 100)
  }
]

const pointName = ["Point A", "Point B", "Point C", "Point D"];


export default class SliderManager extends BaseSliderManager {
  pointCheckboxs: Checkbox[] = [];
  private pointChecklist = Array(4).fill(false);
  constructor() {
    super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
    this.checkVertical();
    this.addCheckBoxs();
  }
  checkVertical() {
    if (this.dim.WIDTH < this.dim.HEIGHT) {
      const slider = this.sliders[0];
      this.sliders.shift();
      slider.setSliderVisible(false)
    }
  }
  handleCheckbox(index: number, v: boolean) {
    this.pointChecklist[index] = v;
    eventBus.emit(EnumEventBus.setPointChecklist, this.pointChecklist);
  }
  addCheckBoxs() {
    const coords = getPointCheckboxCoords(this.dim);
    this.pointCheckboxs = ANGLE_COLORS.map((e, eI) =>
      new Checkbox(coords[eI], pointName[eI], e, false, (label: string, v: boolean) => this.handleCheckbox(eI, v)));
    this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxs.forEach(cbox => cbox.setScale(.8));
  }
}


function getPointCheckboxCoords(dim: { WIDTH: number, HEIGHT: number }) {
  const getCoordHorizontal = (eI: number) => ({ x: 1165 + (eI > 1 ? 180 : 0), y: 775 + (eI % 2 == 1 ? 50 : 0) })
  const getCoordVertical = (eI: number) => ({
    x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
    y: dim.HEIGHT / 2 + 500 + (eI % 2 == 1 ? 40 : 0)
  })
  const coords = Array(4).fill(null).map((e, eI) => dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI));
  return coords
}